export default "__VITE_ASSET__50779232__"